import { IndustryConfig } from '../../../types'

export const manufacturingConfig: IndustryConfig = {
  id: 'manufacturing',
  name: 'Manufacturing',
  icon: '���',
  description: 'Manufacturing and production companies',
  
  businessTypes: [
    {
      id: 'discrete-manufacturing',
      name: 'Discrete Manufacturing',
      description: 'Assembled products and discrete items'
    },
    {
      id: 'process-manufacturing',
      name: 'Process Manufacturing',
      description: 'Chemical, food, and continuous process production'
    }
  ],
  
  revenueStreamTypes: [
    {
      id: 'product-sales',
      name: 'Product Sales',
      description: 'Manufactured product revenue',
      intelligenceValue: "We'll monitor raw material costs and demand forecasts."
    }
  ],
  
  supplierCategories: [
    {
      id: 'raw-materials',
      name: 'Raw Materials',
      suppliers: ['Steel Suppliers', 'Plastics & Polymers', 'Chemical Suppliers'],
      spendRanges: ['Under $100K', '$100K-$500K', '$500K-$2M', 'Over $2M']
    }
  ],
  
  competitiveFactors: [
    'Production efficiency',
    'Quality standards',
    'Cost competitiveness',
    'Delivery performance'
  ]
}
